import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "announce-detail"
  }, [_c('a-breadcrumb', {
    attrs: {
      "separator": ""
    }
  }, [_c('a-breadcrumb-item', [_c('router-link', {
    attrs: {
      "data-permission": "notice_details_to_AnnounceList",
      "id": "notice_details_to_AnnounceList",
      "to": {
        name: 'AnnounceList',
        params: {
          noCache: 1
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.t('announce.index', '消息通知')))])], 1), _c('a-breadcrumb-separator', [_vm._v(">")]), _c('a-breadcrumb-item', [_vm._v(_vm._s(_vm.tc('公告详情')))])], 1), _c('tip', {
    staticClass: "mt-10"
  }), _c('div', {
    staticClass: "pt-50 pb-50 pl-100 pr-100"
  }, [!_vm.detailPending && _vm.announceDetail.id ? _c('div', [_c('h2', {
    staticClass: "tc announce-detail-title"
  }, [_vm._v(_vm._s(_vm.announceDetail.title))]), _c('p', {
    staticClass: "tc"
  }, [_vm._v(_vm._s(_vm.announceDetail.released_on))]), _c('p', {
    staticClass: "mt-20 announce-detail-article",
    domProps: {
      "innerHTML": _vm._s(_vm.$util.filterXSS(_vm.announceDetail.content))
    }
  }), _vm.announceDetail.attachment_list && _vm.announceDetail.attachment_list.length ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.t('附件：')))]), _vm._l(_vm.announceDetail.attachment_list, function (item) {
    return _c('span', {
      key: item.id,
      staticClass: "ml-20"
    }, [_c('a', {
      staticClass: "mr-10",
      attrs: {
        "download": "",
        "href": item.remote_url,
        "target": /jpg|png|gif|jpeg/.test(item.remote_url) ? '_blank' : ''
      }
    }, [_c('a-icon', {
      staticClass: "mr-3",
      attrs: {
        "type": "file"
      }
    }), _vm._v(_vm._s(item.file_name) + " ")], 1), _c('a', {
      staticClass: "mr-10",
      attrs: {
        "download": "",
        "href": item.remote_url,
        "fbu-analyse-name": $t("\u4E0B\u8F7D")
      }
    }, [_vm._v(_vm._s(_vm.t('下载')))])]);
  })], 2) : _vm._e()]) : _vm._e()]), !_vm.detailPending && !_vm.announceDetail.id ? _c('a-empty', {
    staticClass: "mt-50",
    attrs: {
      "description": _vm.t('暂无数据')
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };